import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Stars } from './Stars';
import { GMAIL_REVIEWS } from '../lib/data';
const AUTO_ADVANCE_MS = 5000;
export function GmailReviews() {
  const carouselRef = useRef<HTMLDivElement>(null);
  const activeIndexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [reducedMotion, setReducedMotion] = useState(false);
  const setCurrentReview = useCallback((index: number) => {
    activeIndexRef.current = index;
    setActiveIndex(index);
  }, []);
  const scrollToReview = useCallback((index: number, behavior: ScrollBehavior = 'smooth') => {
    const carousel = carouselRef.current;
    const review = carousel?.children[index] as HTMLElement | undefined;
    if (!carousel || !review) return;
    carousel.scrollTo({
      left: review.offsetLeft - carousel.offsetLeft,
      behavior
    });
    setCurrentReview(index);
  }, [setCurrentReview]);
  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const syncMotionPreference = () => setReducedMotion(media.matches);
    syncMotionPreference();
    media.addEventListener('change', syncMotionPreference);
    return () => media.removeEventListener('change', syncMotionPreference);
  }, []);
  useEffect(() => {
    if (reducedMotion) return;
    const timer = window.setInterval(() => {
      const nextIndex = (activeIndexRef.current + 1) % GMAIL_REVIEWS.length;
      scrollToReview(nextIndex);
    }, AUTO_ADVANCE_MS);
    return () => window.clearInterval(timer);
  }, [reducedMotion, scrollToReview]);
  const handleScroll = () => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    const reviews = Array.from(carousel.children) as HTMLElement[];
    const closestIndex = reviews.reduce((closest, review, index) => {
      const distance = Math.abs(review.offsetLeft - carousel.offsetLeft - carousel.scrollLeft);
      const closestDistance = Math.abs(reviews[closest].offsetLeft - carousel.offsetLeft - carousel.scrollLeft);
      return distance < closestDistance ? index : closest;
    }, 0);
    setCurrentReview(closestIndex);
  };
  return <section className="py-6" aria-label="Reseñas por correo de jugadoras" data-id="element-131" data-mp="cp3ahh8yvbco">
      <div ref={carouselRef} onScroll={handleScroll} className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-2" aria-roledescription="carrusel" data-id="element-132" data-mp="hl1wiy6toh9x">
        {GMAIL_REVIEWS.map((src, i) => <div key={src} className="w-[76vw] max-w-[280px] shrink-0 snap-center" data-id="element-133" data-mp="vll3s33grjb1" data-mpi={i}>
            <img src={src} alt={`Captura de reseña por correo de una jugadora ${i + 1}`} className="aspect-[9/16] w-full rounded-xl border border-white/10 object-cover object-top shadow-lg" data-id="element-134" data-mp="10d32sllxf9td" />
          </div>)}
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" aria-label="Seleccionar reseña" data-id="element-135" data-mp="19bohg5oa24ov">
        {GMAIL_REVIEWS.map((_, i) => <button key={i} type="button" onClick={() => scrollToReview(i)} aria-label={`Mostrar reseña ${i + 1}`} aria-current={activeIndex === i ? 'true' : undefined} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 ${activeIndex === i ? 'w-6 bg-hockey-pink' : 'w-2.5 bg-white/30'}`} data-id="element-136" data-mp="2yuwpetpafn11" data-mpi={i} />)}
      </div>
      <p className="mt-2 text-center text-[11px] text-white/40" data-id="element-137" data-mp="3hn8v9qf5h6fx">Desliza o espera para ver más opiniones</p>
    </section>;
}